import {userModel} from 'src/datamodels/permissions'

const userReducer = (state=userModel(),action) => {
    if (action.type === "UPDATE_CURRENT_USER") {
        return Object.assign({}, state, action.payload);
    }

    if(action.type==='LOGOUT_USER'){
        return Object.assign({},userModel(),action.payload);
    }

    return state;
};

let exprt = {
    user:userReducer
};

export default exprt;
